// Sentry init + production console suppression, extracted from index.tsx so
// this side-effect import can be pinned ABOVE the (now static) App import —
// organize-imports hoists `import App` to the top of the named-import run, and
// monitoring must be armed before the App module graph evaluates (a boot-time
// module throw would otherwise blank-page unreported; module-scope logs would
// escape suppression). Evaluation order: bootTheme → this → App graph.
import * as Sentry from '@sentry/react';
import { resolveUiV4 } from '../lib/uiFlag';
import { useAuthStore } from '../store';

const originalUserRole = useAuthStore.getState().originalUserRole;
if (
  import.meta.env.VITE_MODE !== 'development' &&
  import.meta.env.VITE_MODE !== 'staging' &&
  import.meta.env.VITE_MODE !== 'demo' &&
  originalUserRole !== 'superadmin'
) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.warn = () => {};
}

if (
  import.meta.env.VITE_MODE === 'production' ||
  import.meta.env.VITE_MODE === 'demo' ||
  import.meta.env.VITE_MODE === 'staging' ||
  import.meta.env.VITE_MODE === 'development1'
) {
  const releaseString = `ap-v3-web-${import.meta.env.VITE_RELEASE_ENV}-${
    import.meta.env.VITE_RELEASE_TIME
  }-${import.meta.env.VITE_RELEASE_VERSION}`;
  const envString = `${import.meta.env.VITE_MODE} - ${import.meta.env.VITE_RELEASE_ENV}`;
  console.log('releaseString', releaseString);
  console.log('envString', envString);
  Sentry.init({
    dsn: 'https://44f1080ae131c8fa754d498294b077d4@o444384.ingest.us.sentry.io/4509250748678144',
    integrations: [Sentry.browserTracingIntegration()],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: false,
    tracesSampleRate: 0.0, // we don't want transactions - tracks too many
    environment: envString,
    release: releaseString,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });

  // ReactGA.initialize('UA-71336374-3');
}

// Tag every Sentry event from the v4 shell so triage can separate the two
// worlds (spec § Error handling). Set once at boot, only when v4 is active.
// R2-G60: resolveUiV4() is always true (Sentry tag); gate retirement is R22.
if (resolveUiV4()) {
  Sentry.setTag('ui', 'v4');
}
